import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'
import { RetentionGroupsWidget } from '@/widgets/analytics/retention'

export const RetentionGroupsPage = () => {
    const { activeWorkspace } = useActiveWorkspace()

    if (activeWorkspace.workspace_type !== 'channel') {
        return null
    }

    return <RetentionGroupsWidget channelId={activeWorkspace.channel_id} />
}
